import { isWheelCatalogTemplateId, type WheelCatalogTemplateId } from "../../types/wheel";

export type { WheelCatalogTemplateId };
export {
  buildDefaultWheelConfigForTemplate,
  WHEEL_CATALOG_TEMPLATE_IDS,
  isWheelCatalogTemplateId,
} from "../../types/wheel";

/** Merchant-facing wheel product templates (same engine; maps to wheelConfig.interaction). */

export interface WheelCatalogTemplate {
  id: WheelCatalogTemplateId;
  /** Card title (distinct from backend game name). */
  title: string;
  /** Short merchant-facing description. */
  description: string;
  /** Mini copy under the preview. */
  previewCaption: string;
}

export const WHEEL_CATALOG_TEMPLATES: readonly WheelCatalogTemplate[] = [
  {
    id: "lead_capture",
    title: "Lead Capture Wheel",
    description:
      "Collect email or phone before the spin. Best for list growth and remarketing while keeping the same wheel experience.",
    previewCaption: "Contact first, then spin",
  },
  {
    id: "instant_discount",
    title: "Instant Discount Wheel",
    description:
      "Spin immediately and surface discount codes or % off at checkout — commerce-first, no form gate.",
    previewCaption: "Spin now · discount outcomes",
  },
] as const;

export function parseWheelTemplateQueryParam(
  raw: string | null
): WheelCatalogTemplateId | null {
  if (raw == null) return null;
  return isWheelCatalogTemplateId(raw) ? raw : null;
}
